import { toast as toaster } from 'react-toastify'
import ToastNotification from 'components/Notifications/ToastNotification'

export const useToast = (config = {}) => {
    const handler = (text, icon, props) =>
        toaster(<ToastNotification text={text} icon={icon} {...props} />, { ...config })

    const toast = {
        info: (text, props) => handler(text, 'info', props),
        error: (text, props) => handler(text, 'error', props),
        success: (text, props) => handler(text, 'check', props),
        warning: (text, props) => handler(text, 'warning', props),
        question: (text, props) => handler(text, 'question', props),
    }

    return { toast, toaster: handler }
}
